import { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Col, Divider, Modal, Row, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import { AlertType, useAlert } from "../provider/AlertProvider";
import { AddressType } from "./AddressMaker";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";

import DataTable from "./DataTable";
import RentRegisterB2b from "./RentRegisterB2b";
import moment from "moment";

function RentB2bList() {
    const alert = useAlert();

    const [b2bs, setB2bs] = useState<Types.Page<Types.B2bDto>>(Common.EMPTY_PAGE);
    const [currentB2b, setCurrentB2b] = useState<Types.B2bDto>();
    const [editMode, setEditMode] = useState<string>("none");
    const [openDeleteB2b, setOpenDeleteB2b] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setCurrentB2b(undefined);
        requestGetB2bs();
    }, [location]);

    const columns: ColumnsType<Types.B2bDto> = [
        {
            align: "center",
            title: "번호",
            dataIndex: "num",
            key: "num",
            render: (item, record, index) => {
                const pageable = b2bs.pageable;
                return b2bs.totalElements - pageable.pageSize * pageable.pageNumber - index;
            },
        },
        {
            align: "center",
            title: "회사/단체명",
            dataIndex: "b2bName",
            key: "b2bName",
        },
        {
            align: "center",
            title: "프로모션코드",
            dataIndex: "promotionCode",
            key: "promotionCode",
        },
        {
            align: "center",
            title: "쿠폰",
            dataIndex: "coupon",
            key: "coupon",
            render: (_, row) => row?.coupon?.couponName || String.dash,
        },
        {
            align: "center",
            title: "등록일",
            dataIndex: "createdDate",
            key: "createdDate",
            render: (_, row) => <>{moment(row.createdDate).format(Common.FORMAT_DATE)}</>,
        },
        {
            align: "center",
            title: " ",
            dataIndex: "action",
            key: "action",
            render: (_, row) => {
                return (
                    <>
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setCurrentB2b(row);
                                setEditMode("update");
                            }}
                        >
                            {String.update}
                        </Button>
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setCurrentB2b(row);
                                setOpenDeleteB2b(true);
                            }}
                        >
                            {String.remove}
                        </Button>
                    </>
                );
            },
        },
    ];

    //get b2bs
    const requestAxiosGetB2bs = async () => {
        const pageNumber = +(new URLSearchParams(location.search).get("page") ?? "1");
        const response = await utilAxiosWithAuth().get(Request.RENT_B2B_LIST_URL, {
            params: { page: pageNumber - 1, size: Common.PAGE_SIZE },
        });

        return response.data;
    };

    const { loading: loadingGetB2bs, error: errorGetB2bs, data: resultGetB2bs, execute: requestGetB2bs } = useAsyncAxios(requestAxiosGetB2bs);

    useEffect(() => {
        if (resultGetB2bs === null) return;

        console.log("resultGetB2bs", resultGetB2bs);
        setB2bs(resultGetB2bs.b2bs);
    }, [resultGetB2bs]);

    useEffect(() => {
        if (errorGetB2bs === null) return;

        console.log("errorGetB2bs", errorGetB2bs);
    }, [errorGetB2bs]);

    const onChange = (pagination: any) => {
        navigate(`?page=${pagination.current}`);
    };

    //add b2b
    const requestAxiosAddB2b = async (data: Types.B2bDto) => {
        const response = await utilAxiosWithAuth().post(Request.RENT_B2B_URL, data);
        return response.data;
    };

    const { loading: loadingAddB2b, error: errorAddB2b, data: resultAddB2b, execute: requestAddB2b } = useAsyncAxios(requestAxiosAddB2b);

    useEffect(() => {
        if (resultAddB2b === null) return;

        requestGetB2bs();
        alert.setAlert(AlertType.SUCCESS, "B2B 추가 성공", "B2B 추가를 완료하였습니다.");
    }, [resultAddB2b]);

    useEffect(() => {
        if (errorAddB2b === null) return;

        console.log("errorB2b", errorAddB2b);
        alert.setAlert(errorAddB2b.response.data.code, "B2B 추가 실패", errorAddB2b.response.data.message);
    }, [errorAddB2b]);

    //update b2b
    const requestAxiosUpdateB2b = async (b2bId: number, data: any) => {
        const response = await utilAxiosWithAuth().put(Request.RENT_B2B_URL + "/" + b2bId, data);
        return response.data;
    };

    const { loading: loadingUpdateB2b, error: errorUpdateB2b, data: resultUpdateB2b, execute: requestUpdateB2b } = useAsyncAxios(requestAxiosUpdateB2b);

    useEffect(() => {
        if (resultUpdateB2b === null) return;

        requestGetB2bs();
        alert.setAlert(AlertType.SUCCESS, "B2B 수정 성공", "B2B 수정을 완료하였습니다.");
    }, [resultUpdateB2b]);

    useEffect(() => {
        if (errorUpdateB2b === null) return;

        console.log("errorUpdateB2b", errorUpdateB2b);
        alert.setAlert(errorUpdateB2b.response.data.code, "B2B 수정 실패", errorUpdateB2b.response.data.message);
    }, [errorUpdateB2b]);

    const requestAxiosRemoveB2b = async (b2b: Types.B2bDto) => {
        const response = await utilAxiosWithAuth().delete(Request.RENT_B2B_URL + "/" + b2b.b2bId);
        return response.data;
    };

    const { loading: loadingRemoveB2b, error: errorRemoveB2b, data: resultRemoveB2b, execute: requestRemoveB2b } = useAsyncAxios(requestAxiosRemoveB2b);

    useEffect(() => {
        if (resultRemoveB2b === null) return;

        setEditMode("none");
        setCurrentB2b(undefined);
        requestGetB2bs();
    }, [resultRemoveB2b]);

    useEffect(() => {
        if (errorRemoveB2b === null) return;
        console.log("errorRemoveB2b", errorRemoveB2b);
    }, [errorRemoveB2b]);

    const handleRemoveB2bOk = () => {
        setOpenDeleteB2b(false);
        requestRemoveB2b(currentB2b);
    };

    const handleRemoveB2bCancel = () => {
        setEditMode("none");
        setOpenDeleteB2b(false);
        setCurrentB2b(undefined);
    };

    const onFinish = (values: any, address?: AddressType) => {
        delete values["fullAddress"];
        const data: Types.B2bDto = {
            ...values,
            address: address?.address,
            addressDetails: address?.addressDetails,
            coupon: { couponId: values?.coupon?.couponId || null },
            rentCars: values?.rentCars?.map((carId: string) => ({ rentCarId: carId })),
            managers: values?.managers?.map((email: string) => ({ email: email })),
        };

        console.log("data", data);

        if (editMode === "add") {
            requestAddB2b(data);
        } else if (editMode === "update") {
            requestUpdateB2b(currentB2b?.b2bId, data);
        }
    };

    return (
        <>
            <Row justify={"space-between"}>
                <Col span={6}>
                    <Divider orientation="left">
                        <span>B2b</span>
                    </Divider>
                </Col>
                <Space>
                    <Button
                        onClick={() => {
                            setCurrentB2b(undefined);
                            setEditMode("add");
                        }}
                    >
                        {String.userAdd}
                    </Button>
                </Space>
            </Row>
            <DataTable
                rowKey={(row: Types.B2bDto) => row.b2bId}
                loading={loadingGetB2bs}
                hasScroll={false}
                columns={columns}
                dataSource={b2bs.content}
                tableSize={Common.PAGE_SIZE}
                pageNumber={b2bs.pageable.pageNumber + 1}
                total={b2bs.totalElements}
                onChange={onChange}
            />
            {editMode !== "none" && <RentRegisterB2b editMode={editMode} b2b={currentB2b} onFinish={onFinish} />}
            {openDeleteB2b && (
                <Modal open={openDeleteB2b} onOk={handleRemoveB2bOk} onCancel={handleRemoveB2bCancel}>
                    B2B를 삭제하시겠습니까?
                </Modal>
            )}
        </>
    );
}

export default RentB2bList;
